export default __webpack_public_path__ + "9ada7fb40ac3741132929de0d5b04e8c.png";